import React, { useState } from "react";
import "./Querydata.css";
import { RiFileCloseLine } from "react-icons/ri";

type FileItem = {
  name: string;
  keywords: string;
};

type QuerydataProps = {
  onChooseFile?: (fileName: string) => void;
  onChooseFiles?: (fileNames: string[]) => void;
  onClear?: () => void;
  nlGraphData: any;
  searchQuery?: string;
  fileError?: string;
  isRadio?: boolean;
};


const Querydata: React.FC<QuerydataProps> = ({ onChooseFile, onChooseFiles, onClear, nlGraphData, searchQuery, fileError, isRadio }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState('');
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const files: FileItem[] = nlGraphData?.document_result ? nlGraphData.document_result
    .filter((doc: any) => {
      const fileName = doc.file_name || '';
      return isRadio ? fileName.toLowerCase().endsWith('.xls') || fileName.toLowerCase().endsWith('.xlsx') : true;
    })
    .map((doc: any) => ({
      name: doc.file_name || '',
      keywords: Array.isArray(doc.keywords) ? doc.keywords.join(', ') : doc.keywords || ''
    })) : [];

  const handleClearClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmYes = () => {
    setShowConfirmModal(false);
    if (onClear) {
      onClear();
    }
  };

  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };

  const handleChooseClick = () => {
    onChooseFile?.(selectedFileName);
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedSelectedItems;
    if (checked) {
      updatedSelectedItems = [...selectedItems, value];
    } else {
      updatedSelectedItems = selectedItems.filter((item) => item !== value);
    }
    setSelectedItems(updatedSelectedItems);
    onChooseFiles?.(updatedSelectedItems);
  };



  return (
    <>
      <div className="query-header">
        <div className="query-header-left">
          <h2 className="query-title">Results for {searchQuery}</h2>
          <p className="query-subtitle">{files.length} results</p>

          {fileError && (
            <div className="error-message">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', flexShrink: 0 }}>
                <path d="M12 2L22 20H2L12 2Z" fill="#dc3545" />
                <path d="M12 8V13" stroke="white" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="17" r="1" fill="white" />
              </svg>
              {fileError}
            </div>
          )}
        </div>

        <button className="query-clear-btn" title="Clear files" onClick={handleClearClick}>
          <RiFileCloseLine size={20} />
        </button>
      </div>

      {files.length > 0 && (
        <div className="query-container">
          <div className="query-table-wrapper">
            <table className="query-table">
              <thead>
                <tr>
                  <th></th>
                  <th>File</th>
                  <th># keywords</th>
                </tr>
              </thead>
              <tbody>
                {files.map((file, index) => (
                  <tr key={index}>
                    <td>
                      {
                        isRadio ? (
                          <input
                            type="radio"
                            name="selectedFile"
                            className="query-radio"
                            value={file.name}
                            checked={selectedFileName === file.name}
                            onChange={() => setSelectedFileName(file.name)}
                          />
                        ) : (
                          <input
                            type="checkbox"
                            name="selectedFile"
                            className="query-radio"
                            value={file.name}
                            onChange={handleCheckboxChange}
                          />
                        )}
                    </td>

                    <td>{file.name}</td>
                    <td>{file.keywords}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {isRadio && (
            <div className="query-footer">
              <button className="query-button" onClick={handleChooseClick}>Choose file</button>
            </div>
          )}
        </div>
      )}
      {/* Custom Confirmation Modal */}
      {showConfirmModal && (
        <div className="confirm-modal-overlay">
          <div className="confirm-modal">
            <div className="confirm-modal-body">
              <p>Are you sure you want to clear the file?</p>
            </div>
            <div className="confirm-modal-footer">
              <button className="confirm-btn confirm-btn-no" onClick={handleConfirmNo}>
                No
              </button>
              <button className="confirm-btn confirm-btn-yes" onClick={handleConfirmYes}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Querydata;
